import React from "react";
import { Card, CardContent } from "../components/ui/card";
import { Trophy, Award, Medal, Star } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Img1 from "../assets/SalesManager.jpeg";
import Founder1 from "../assets/founder1.jpeg";
import Founder2 from "../assets/founder2.jpeg";
import Award1 from "../assets/award1.jpeg";
import Award2 from "../assets/award2.jpeg";
import BannerImg from "../assets/banner.jpeg";

const AboutPage = () => {
  return (
    <>
      <Navbar />

      <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-white">
        {/* HERO */}
        <section className="py-24 bg-emerald-900 text-white text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">Our Story</h1>
          <p className="text-emerald-100 max-w-2xl mx-auto text-lg">
            Reco Agro Traders is a leading name in the fresh fruits trading and supply industry, committed to delivering premium quality produce globally.
          </p>
        </section>

        {/* STORY */}
        <section className="py-20">
          <div className="max-w-6xl mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              About Us
            </h2>

            <p className="text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Welcome to Reco Agro Traders — a trusted name in the fresh fruits
              trading and supply industry. Established in March 2025, our
              company is committed to delivering premium quality fresh fruits to
              both domestic and international markets with reliability,
              transparency, and professional service standards. Reco Agro
              Traders specializes in the sourcing, trading, packaging, and
              supply of seasonal and non-seasonal fresh fruits directly from
              trusted farms and market networks across India. We focus on
              maintaining freshness, quality, proper grading, and timely
              delivery to ensure complete satisfaction for our customers and
              business partners. Our company serves wholesalers, retailers,
              importers, exporters, supermarkets, distributors, and
              institutional buyers by providing quality fruit supplies according
              to market demand and customer requirements. With a strong
              understanding of agricultural markets and supply chain management,
              we aim to build long-term business relationships based on trust
              and consistent service. We deal in a wide range of fresh fruits
              including bananas, mangoes, grapes, pomegranates, apples, oranges,
              watermelons, and other seasonal produce depending on availability
              and market season. Every shipment is handled with proper care to
              maintain quality standards during transportation and delivery. At
              Reco Agro Traders, we believe that genuine business comes from
              honest commitments, fair dealings, and customer satisfaction. Our
              goal is to expand our presence in domestic as well as
              international markets by maintaining professional business
              practices and supplying fresh agricultural produce with efficiency
              and integrity.
            </p>
          </div>
        </section>
        {/* why choose us */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Why Choose Us
            </h2>
            <p className="text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Fresh and quality fruit supply Domestic and international trading
              network Transparent business dealings Timely delivery and
              logistics support Customer-focused service approach Reliable
              sourcing from trusted suppliers and markets “Delivering Freshness
              with Trust and Commitment.”
            </p>
          </div>
        </section>

        {/* PARTNERSHIP BANNER */}
        <section className="py-20 bg-gradient-to-br from-emerald-50 to-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="overflow-hidden rounded-3xl shadow-2xl border border-emerald-100 bg-white">
              <img
                src={BannerImg}
                alt="Reco Agro Traders Network"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </section>

        {/* OWNERS */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">
              Leadership Team
            </h2>

            <div className="grid md:grid-cols-3 gap-10">
              {/* OWNER 1 */}
              <Card className="text-center hover:shadow-2xl transition-all">
                <CardContent className="p-8">
                  <img
                    src={Founder1}
                    alt="Owner 1"
                    className="w-32 h-32 mx-auto rounded-full object-cover mb-5 border-4 border-emerald-100"
                  />
                  <h3 className="text-xl font-bold">Mohd Uzair Mujiboodin</h3>
                  <p className="text-emerald-700 font-medium">Founder & CEO</p>
                  <p className="text-gray-600 text-sm mt-3">
                    Leading global export strategy and farmer partnerships.
                  </p>
                </CardContent>
              </Card>

              {/* OWNER 2 */}
              <Card className="text-center hover:shadow-2xl transition-all">
                <CardContent className="p-8">
                  <img
                    src={Founder2}
                    alt="Owner 2"
                    className="w-32 h-32 mx-auto rounded-full object-cover mb-5 border-4 border-emerald-100"
                  />
                  <h3 className="text-xl font-bold">Mohd Zaid</h3>
                  <p className="text-emerald-700 font-medium">
                    Co-Founder & COO
                  </p>
                  <p className="text-gray-600 text-sm mt-3">
                    Driving operations, quality control, and supply chain
                    excellence.
                  </p>
                </CardContent>
              </Card>

              {/* Sales Manager  */}
              <Card className="text-center hover:shadow-2xl transition-all">
                <CardContent className="p-8">
                  <img
                    src={Img1}
                    className="w-32 h-32 mx-auto rounded-full object-cover mb-5 border-4 border-emerald-100"
                  />
                  <h3 className="text-xl font-bold">Mina Rahemani</h3>
                  <p className="text-emerald-700 font-medium">
                    Senior Sales Manager
                  </p>
                  <p className="text-gray-600 text-sm mt-3">
                    8+ Years Experience In Export And Import Industry
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>

        {/* AWARDS */}
        <section className="py-20 bg-gradient-to-br from-stone-50 to-emerald-50">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">
              Awards & Recognition
            </h2>

            <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 place-items-center">
              {/* AWARD 1 */}
              <div className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition w-full max-w-sm">
                <img
                  src={Award2}
                  alt="Best Export Company Award"
                  className="w-full h-48 object-cover"
                />

                <div className="p-6 text-center">
                  <Trophy className="h-10 w-10 text-amber-500 mx-auto mb-4" />
                  <h3 className="font-bold text-lg">Best Export Company</h3>

                  <p className="text-sm text-gray-600 mt-2">
                    leading best quality banana exporter of the year
                  </p>
                </div>
              </div>

              {/* AWARD 2 */}
              <div className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition w-full max-w-sm">
                <img
                  src={Award1}
                  alt="Quality Excellence Award"
                  className="w-full h-48 object-cover"
                />

                <div className="p-6 text-center">
                  <Award className="h-10 w-10 text-emerald-600 mx-auto mb-4" />
                  <h3 className="font-bold text-lg">
                    Quality Excellence Award
                  </h3>

                  <p className="text-sm text-gray-600 mt-2">
                    Certified for premium quality standards compliance
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* MISSION */}
        <section className="py-20 bg-white">
          <div className="max-w-5xl mx-auto text-center px-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Our Mission
            </h2>

            <p className="text-gray-600 leading-relaxed">
              To empower farmers, deliver premium agricultural products
              globally, and create a sustainable supply chain that benefits both
              producers and international markets.
            </p>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default AboutPage;
